import { render } from "./UserStrain.vue?vue&type=template&id=9939c89c&scoped=true"
import script from "./UserStrain.vue?vue&type=script&lang=js"
export * from "./UserStrain.vue?vue&type=script&lang=js"

import "./UserStrain.vue?vue&type=style&index=0&id=9939c89c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9939c89c"]])

export default __exports__